import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GROWTHBOOK_FEATURE_FLAGS } from '@web-app/constants/growthbook';

export const useSupervisionTasksEnabled = (): boolean => {
  return useFeatureIsOn(GROWTHBOOK_FEATURE_FLAGS.SUPERVISION_TASKS);
};
